import { createTheme, MantineColorsTuple } from '@mantine/core';

const nifoni: MantineColorsTuple = [
  '#f0f6f9',
  '#e2eaee',
  '#c0d3dd',
  '#9abccd',
  '#7ca8bf',
  '#689bb7',
  '#5d95b4',
  '#4c829f',
  '#41738f',
  '#16303d',
];

export const theme = createTheme({
  colors: {
    nifoni,
  },
});
